export const WINDOW_KEY = 'commonQueue';



// WEBPACK FOOTER //
// lib/constants.js